import React from 'react';
import styled from 'styled-components';

import { useNavigate } from 'react-router-dom';
import { Button } from '@common/Button';
import { KeyboardArrowLeft, KeyboardArrowRight, KeyboardArrowUp } from '@mui/icons-material';
import { alpha, Tooltip } from '@mui/material';

const NavigationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.line.light};
  padding: 28px;
  margin: 0 28px;
  background: ${({ theme }) => alpha(theme.background.light, 0.5)};
  gap: 24px;
  border-radius: 0 0 8px 8px;

  #buttonText {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export type NavItem = {
  href: string;
  name: string;
};

interface Props {
  previousArticle: NavItem | undefined;
  nextArticle: NavItem | undefined;
  onBackToTop: () => void;
}

export const DocsNavigation: React.FC<Props> = ({ previousArticle, nextArticle, onBackToTop }) => {
  const navigate = useNavigate();

  return (
    <NavigationContainer>
      {previousArticle && (
        <Tooltip placement='top' arrow title='Previous Article'>
          <Button variant='text' onClick={() => navigate(previousArticle.href)} startIcon={<KeyboardArrowLeft />}>
            <span id='buttonText'>{previousArticle.name}</span>
          </Button>
        </Tooltip>
      )}
      <div style={{ flex: '0 0 180px', display: 'flex', justifyContent: 'center' }}>
        <Button
          startIcon={<KeyboardArrowUp />}
          onClick={onBackToTop}
          style={{ whiteSpace: 'nowrap', minWidth: '140px' }}
        >
          Back to Top
        </Button>
      </div>
      {nextArticle && (
        <Tooltip placement='top' arrow title='Next Article'>
          <Button variant='text' onClick={() => navigate(nextArticle.href)} endIcon={<KeyboardArrowRight />}>
            <span id='buttonText'>{nextArticle.name}</span>
          </Button>
        </Tooltip>
      )}
    </NavigationContainer>
  );
};
